import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { OfferDetailsComponent } from './offer-details.component';
import { OfferDetailsRoutingModule } from './offer-details-routing.module';
import { OfferService } from './offer.service';
import { SharedModule } from '../shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SwiperModule } from 'swiper/angular';
import { VideoModule } from '../video/video.module';
import { OfferCreateDialogComponent } from './offer-create.dialog.component';


@NgModule({
  imports: [OfferDetailsRoutingModule, SharedModule, ReactiveFormsModule, MatTableModule, MatExpansionModule, MatTabsModule, MatInputModule, MatSelectModule, MatFormFieldModule, SwiperModule, VideoModule],
  declarations: [OfferDetailsComponent, OfferCreateDialogComponent],
  exports: [OfferDetailsComponent],
  providers: [OfferService],
})
export class OfferDetailsModule { }
